// src/components/CurrencyToggle.jsx
import { useCurrency } from "../context/CurrencyContext";

export default function CurrencyToggle({ className = "", onDark = false }) {
  const { currency, setCurrency } = useCurrency();

  const containerClass = onDark
    ? "flex items-center rounded-lg border border-white/25 overflow-hidden text-xs font-medium"
    : `flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden text-xs font-medium`;

  const buttonClass = (isActive) => {
    if (onDark) {
      return `flex items-center gap-1 px-2 py-1.5 transition ${
        isActive ? "bg-white text-purple-700" : "bg-transparent text-white/80 hover:bg-white/10"
      }`;
    }
    return `flex items-center gap-1 px-2 py-1.5 transition ${
      isActive
        ? "bg-purple-600 text-white"
        : "bg-white dark:bg-gray-900 text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800"
    }`;
  };

  return (
    <div className={`${containerClass} ${className}`}>
      <button onClick={() => setCurrency("NGN")} className={buttonClass(currency === "NGN")} aria-label="Switch to Naira">
        <span>🇳🇬</span> NGN
      </button>
      <button onClick={() => setCurrency("USD")} className={buttonClass(currency === "USD")} aria-label="Switch to US Dollar">
        <span>🇺🇸</span> USD
      </button>
    </div>
  );
}